import React from 'react';

const GraphPoints = () => {
  return (
    <svg viewBox="0 0 64 24">
      <circle cx="12" cy="12" r="12"></circle>
      <circle cx="52" cy="12" r="12"></circle>
      <rect x="8" y="10" width="48" height="4"></rect>
    </svg>
  )
}

export default GraphPoints